import { Apiv2ServiceException as __BaseException } from "./Apiv2ServiceException";
export class BadRequestError extends __BaseException {
    name = "BadRequestError";
    $fault = "client";
    description;
    requestId;
    reason;
    constructor(opts) {
        super({
            name: "BadRequestError",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, BadRequestError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.reason = opts.reason;
    }
}
export class InternalServerError extends __BaseException {
    name = "InternalServerError";
    $fault = "server";
    description;
    requestId;
    constructor(opts) {
        super({
            name: "InternalServerError",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalServerError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
    }
}
export class NotAuthenticatedError extends __BaseException {
    name = "NotAuthenticatedError";
    $fault = "client";
    description;
    requestId;
    constructor(opts) {
        super({
            name: "NotAuthenticatedError",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, NotAuthenticatedError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
    }
}
export class NotAuthorizedError extends __BaseException {
    name = "NotAuthorizedError";
    $fault = "client";
    description;
    requestId;
    resource;
    operation;
    constructor(opts) {
        super({
            name: "NotAuthorizedError",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, NotAuthorizedError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.resource = opts.resource;
        this.operation = opts.operation;
    }
}
export class NotFoundError extends __BaseException {
    name = "NotFoundError";
    $fault = "client";
    description;
    requestId;
    resource;
    constructor(opts) {
        super({
            name: "NotFoundError",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, NotFoundError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.resource = opts.resource;
    }
}
export class ValidationError extends __BaseException {
    name = "ValidationError";
    $fault = "client";
    description;
    requestId;
    fieldList;
    constructor(opts) {
        super({
            name: "ValidationError",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ValidationError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.fieldList = opts.fieldList;
    }
}
